export const ovActions = (state) => state.ovActions
export const ovDetail = (state) => state.ovDetail
